import { createFileRoute } from '@tanstack/react-router';
import WorkflowsPage from '@/pages/setup/workflows/WorkflowsPage';
import { parseWorkflowsSearch, type WorkflowsSearch } from '@/pages/setup/workflows/search';
import { requireSetupPageAccess } from '@/lib/setup-route-guard';

export const Route = createFileRoute('/_authenticated/setup/workflows')({
  beforeLoad: () => requireSetupPageAccess('/setup/workflows'),
  validateSearch: (raw: Record<string, unknown>): WorkflowsSearch => parseWorkflowsSearch(raw),
  component: WorkflowsPage,
});
